const prevActiveSideMap = {}

export default {
  byActionType: {

  },
  byEventType: {
    'MATCH_FORMAT' (event) {
      const { extra } = event
      const {
        kits,
        matchFormat,
        overtimeFormat,
        timerFormat: firstVersionTimerFormats,
        has_golden_set: hasGoldenSet,
        inverse,
        timer_speed_up: timerSpeedUp,
        is_shootout_series_format: isShootoutSeriesFormat,
        has_tackles: hasTackles,
        format_key: formatKey
      } = extra
      const timerFormat = !firstVersionTimerFormats
        ? {
          inverse,
          resetEachPeriod: true
        }
        : firstVersionTimerFormats

      this.setIngameProperty({
        property: 'formatKey',
        value: formatKey
      })

      this.setMatchFormat({
        kits,
        matchFormat,
        overtimeFormat,
        timerFormat,
        timerSpeedUp,
        hasGoldenSet,
        hasTackles
      })

      if (!isShootoutSeriesFormat) return

      this.setShootoutSeriesFormat()
    },
    'POSESSION_1' (event) {
      prevActiveSideMap[event.EventNumber] = this.getActiveSide

      this.setActiveSideMutation('home')
    },
    'POSESSION_2' (event) {
      prevActiveSideMap[event.EventNumber] = this.getActiveSide

      this.setActiveSideMutation('away')
    },
    'SET' (event) {
      this.setIngameProperty({
        property: 'additionalScore',
        value: {
          home: event.extra['sets-1'],
          away: event.extra['sets-2']
        }
      })

      this.setIngameProperty({
        property: 'sets',
        value: {
          home: 0,
          away: 0
        }
      })
    },
    'DOUBLE_FAULT' (event) {
      this.setIngameProperty({
        property: 'additionalScore',
        value: {
          home: event.extra['sets-1'],
          away: event.extra['sets-2']
        }
      })

      this.setIngameProperty({
        property: 'sets',
        value: {
          home: event.ScoreHome,
          away: event.ScoreAway
        }
      })
    },
    'POINT_ACE' (event) {
      this.setIngameProperty({
        property: 'additionalScore',
        value: {
          home: event.extra['sets-1'],
          away: event.extra['sets-2']
        }
      })

      this.setIngameProperty({
        property: 'sets',
        value: {
          home: event.ScoreHome,
          away: event.ScoreAway
        }
      })
    },
    'POINT_WINNER' (event) {
      this.setIngameProperty({
        property: 'additionalScore',
        value: {
          home: event.extra['sets-1'],
          away: event.extra['sets-2']
        }
      })

      this.setIngameProperty({
        property: 'sets',
        value: {
          home: event.ScoreHome,
          away: event.ScoreAway
        }
      })
    },
    'UNFORCED_ERROR' (event) {
      this.setIngameProperty({
        property: 'additionalScore',
        value: {
          home: event.extra['sets-1'],
          away: event.extra['sets-2']
        }
      })

      this.setIngameProperty({
        property: 'sets',
        value: {
          home: event.ScoreHome,
          away: event.ScoreAway
        }
      })
    },
    'POINT' (event) {
      this.setIngameProperty({
        property: 'sets',
        value: {
          home: event.ScoreHome,
          away: event.ScoreAway
        }
      })

      this.setScore(event)
    },
    'CANCEL' (event) {
      const {
        extra,
        ScoreHome,
        ScoreAway,
        RelatedEventNumber
      } = event
      const value = {
        home: ScoreHome,
        away: ScoreAway
      }
      // TODO подумать, как правильно определять тип действия на отмену. Сейчас пусть будет только для score
      this.setScore(event)
      this.setCanceled(event)
      this.refreshDelayedEvents(event)

      // TODO посмотреть что это и как убрать
      if (
        typeof ScoreHome === 'number' &&
        typeof ScoreAway === 'number'
      ) {
        this.setIngameProperty({
          property: 'sets',
          value: {
            home: ScoreHome,
            away: ScoreAway
          }
        })
      }

      value.home = extra['points-1_byPeriod'] || extra['points-1']
      value.away = extra['points-2_byPeriod'] || extra['points-2']

      if (value.home === '_') {
        value.home = '&#8192'
      }

      if (value.away === '_') {
        value.away = '&#8192'
      }

      if (value.home === '50') {
        value.home = 'A'
      }

      if (value.away === '50') {
        value.away = 'A'
      }

      this.setIngameProperty({ property: 'score', value })

      this.setIngameProperty({
        property: 'additionalScore',
        value: {
          home: event.extra['sets-1'],
          away: event.extra['sets-2']
        }
      })

      if (!prevActiveSideMap[RelatedEventNumber]) {
        return
      }

      this.setActiveSideMutation(prevActiveSideMap[RelatedEventNumber])

      delete prevActiveSideMap[RelatedEventNumber]
    },
    'START_PERIOD' (event) {
      const { ScoreHome, ScoreAway } = event

      this.setIngameProperty({
        property: 'sets',
        value: {
          home: ScoreHome,
          away: ScoreAway
        }
      })

      this.setIngameProperty({
        property: 'additionalScore',
        value: {
          home: event.extra['sets-1'],
          away: event.extra['sets-2']
        }
      })
    }
  },
  eventTitles: {
    'START_PERIOD' () {
      return this.$t('trader.badminton.period.start')
    },
    'FINISH_PERIOD' () {
      return this.$t('trader.badminton.period.finish')
    }
  },
  eventCounters: {
    score (home, away) {
      if (!Number(home) && !Number(away)) return ''

      return `${Number(home) === 50 ? 'A' : home}-${Number(away) === 50 ? 'A' : away}`
    }
  }
}
